






import Vue from 'vue';

import SldsSpinner from './Spinner.vue';

export default Vue.extend({
  name: 'SpinnerContainer',
  components: {
    SldsSpinner,
  },
  inheritAttrs: false,
});
